export const getIdFromIri = (fullId: string): string => {
  const id = fullId.split('/').pop();

  if (id !== undefined) {
    return id;
  }

  throw new Error('Invalid Id');
};
